var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-modal"},[_c('a',{staticClass:"close-auth-modal-btn",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.$emit('dismiss')}}},[_c('i',{staticClass:"fal fa-times"})]),_c('Authentication')],1)}
var staticRenderFns = []

export { render, staticRenderFns }